import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useFujiAuth } from './useFujiAuth';
import CenterLoading from '../components/CenterLoading/CenterLoading';

/**
 * 認証の画面
 */
const AuthenContainer = () => {
    const location = useLocation();
    const { isLoading, isAuthenticated } = useFujiAuth();
    if (isLoading) {
        return <CenterLoading overFooter={true} />;
    }
    if (isAuthenticated) {
        return <Navigate to={'/profile'} replace state={{ path: location.pathname }} />;
    }
    return (
        <>
            <Outlet />
        </>
    );
};

export default AuthenContainer;
